import { constants } from "../resource/constants";

export function currentLocation() {
  return new Promise((onResCb, onErrorCB) => {
    navigator.geolocation.getCurrentPosition(onResCb, onErrorCB, {
      enableHighAccuracy: true
    });
  });
}

export function getStates(settings) {
  return Object.keys(settings.translations.states.USA).map(key => ({
    text: settings.translations.states.USA[key],
    value: key
  }));
}

export function extractLocationName({ results }, key, settings) {
  let location;
  if (results && key === "state") {
    results.find(({ address_components }) =>
      address_components.find(
        ({ short_name }) =>
          (location = getStates(settings).find(
            ({ value }) => value === short_name
          ))
      )
    );
  } else {
    /* eslint-disable array-callback-return */
    results.find(({ address_components, types }) => {
      if (types.find(type => type === "country")) {
        address_components.find(({ short_name }) => {
          location = constants.countryCodes[short_name];
        });
      }
    });
  }
  return location instanceof Object ? location.value || "" : location || "";
}
